import React from 'react';
import PropTypes from 'prop-types';

import { PageHeader } from 'inside-out/components/shared/pageHeader';
import { PageNav } from 'inside-out/components/shared/pageNav';

import { linkWithFilter } from 'inside-out/managers/newsAndEventsManager';
import { purple, orange } from 'inside-out/global-styles';

export const CommonPageHeader = ({ activeItem }) => (
	<PageHeader
		background={purple}
		titleText="News and Events"
		titleTextColor="#fff"
		pageNav={
			<PageNav
				textColor="#fff"
				activeTextColor="#fff"
				activeUnderlineColor={orange}
				links={[
					{
						to: linkWithFilter({ base: 'news-and-events' }),
						text: 'Featured',
						isActive: () => activeItem === 'news-and-events',
					},
					{
						to: linkWithFilter({ base: 'news' }),
						text: 'News',
						isActive: () => activeItem === 'news',
					},
					{
						to: linkWithFilter({ base: 'events' }),
						text: 'Events',
						isActive: () => activeItem === 'events',
					},
				]}
			/>
		}
	/>
);

CommonPageHeader.propTypes = {
	activeItem: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/news-and-events/commonPageHeader/component.js